exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// module
exports.push([module.id, ".custom-input {\n  margin-bottom: 10px !important; }\n\n.input-text::after {\n  border-bottom-color: #FF7800 !important; }\n\n.input-label {\n  color: #777777 !important;\n  letter-spacing: .15px;\n  font-size: 1rem !important;\n  top: 3px !important; }\n\n.input-input::after {\n  border-bottom-color: #777777 !important; }\n\n.hidden {\n  display: none; }\n\n.show {\n  display: block;\n  color: #E10A33 !important; }\n\n.w-100 {\n  width: 100%; }\n\n.mr-10 {\n  margin-right: 10px !important; }\n\n.text-right input {\n  text-align: right; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/basic/input/index.scss
// module id = 721
// module chunks = 0